import ResultsGridItemWithState from "../../../js/datasets/search/ResultsGridItem";

export default ResultsGridItemWithState;
